import React from 'react'
import './FooterSocialIcons.css'

const FooterSocialIcons = (props) => {
  return (
    <div className="social-buttons">
      <a className="social-button twitter" href="https://twitter.com/Ford" target="_blank" rel="noopener noreferrer">
        {/* <span className="social-button-link-label">Twitter</span> */}
      </a>
      <a className="social-button linkedin" href="https://www.linkedin.com/company/ford-motor-company" target="_blank" rel="noopener noreferrer">
        {/* <span className="social-button-link-label">Twitter</span> */}
      </a>
      <a className="social-button facebook" href="https://www.facebook.com/ford" target="_blank" rel="noopener noreferrer">
        {/* <span className="social-button-link-label">Twitter</span> */}
      </a>
      <a className="social-button instagram" href="http://instagram.com/ford" target="_blank" rel="noopener noreferrer">
        {/* <span className="social-button-link-label">Twitter</span> */}
      </a>
    </div>
  )
}

export default FooterSocialIcons
